// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"831b1923","208":"f9133b14","318":"a8524040","453":"67bbc46e","723":"6fa105e1","834":"6dc98789","937":"68b080ca"}[chunkId] + ".chunk.js";
};